import { FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { getTranslatedString } from "./FindifyTranslatedString";

const getWorkspaceTextValue = (
    value: any,
    findifyDataContext: FindifyDataContextType | null
) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return getTranslatedString(value, findifyDataContext as FindifyDataContextType);
}

export const getWorkspaceTitle = (findifyDataContext: FindifyDataContextType | null) => {
    return getWorkspaceTextValue(findifyDataContext?.workspace?.name, findifyDataContext)
        || getWorkspaceTextValue(findifyDataContext?.workspace?.app_settings?.general?.title, findifyDataContext)
        || getWorkspaceTextValue(findifyDataContext?.workspace?.app_settings?.app_name, findifyDataContext)
        || 'Museu';
}

export const getWorkspaceDescription = (findifyDataContext: FindifyDataContextType | null) => {
    return getWorkspaceTextValue(findifyDataContext?.workspace?.description, findifyDataContext)
        || getWorkspaceTextValue(findifyDataContext?.workspace?.app_settings?.general?.description, findifyDataContext)
        || getWorkspaceTextValue(findifyDataContext?.workspace?.app_settings?.general?.subtitle, findifyDataContext)
        || '';
}
